/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Events.EmaxSimulate <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 27.8.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 27.8.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.ReportSettings", jQuery.common.VisualBase, {
    dataSettings: null,
    useSignalAssignment: false,
    _create: function () {
        var me = this;
        try {
           
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 350;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
         
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
         
            //set start values
            me.dataSettings = JSON.parse(me.specific.dataSettings);
            me.fnd("#ddl-report-type").val(me.dataSettings.ReportTypeId);
            me.fnd("#ddl-data-type").val(me.dataSettings.DataTypeId);
            me.fnd("#txt-period").val(me.dataSettings.Period);
            me.fnd("#chb-merge-projects").prop("checked", me.dataSettings.Specific.MergeProjects);
            me.fnd("#chb-single-export").prop("checked", me.dataSettings.Specific.SingleExport);
            me.fnd("#ddl-price-type").val(me.dataSettings.Specific.PriceType);

            //set heights
            me.fnd("#div-assignments").height(parseInt(me.element.height() - 120));


            me._showSubLists();




        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            //init event handlers
            me.fnd("#div-btn-save").off("click").on("click", function () { me._save(); }).button().button("disable");
            me.fnd(".formItem .ddl").on("change", function () { me.fnd("#div-btn-save").button("enable") });
            me.fnd(".formItem .input").on("click", function () { me.fnd("#div-btn-save").button("enable") });

            me.fnd("#ddl-report-type").on("change", function () { me._showSubLists()});
        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },


    _showSubLists: function () {
        var me = this;
        try {
            me.useSignalAssignment = (me.fnd("#ddl-report-type").find('option:selected').attr("useSignalAssignment") == "true");
            me.fnd("#div-assignments").html(me.getLoadingIcon());
            var vcV = new vcVisual();
            if (me.useSignalAssignment) {
                me.fnd("#div-sub-menu").show();
             
                vcV.addVisualBaseByName("div-", 'WIDGET_ASSIGNMENT_REPORT_SIGNAL', 'assignments', getCurrentTimestamp(), parseInt($("#div-assignments").height(), 10), parseInt($("#div-assignments").width(), 10), JSON.stringify({ "id": -1, "AssID": me.options.parameter.rid }), JSON.stringify({ "id": -1, "assID": -1 }), 1);


            } else {
                me.fnd("#div-sub-menu").hide();
              
                vcV.addVisualBaseByName("div-", 'WIDGET_REPORT_SIGNAL_META_ASSIGNMENT', 'assignments', window.getCurrentTimestamp(), parseInt($("#div-assignments").height(), 10), parseInt($("#div-assignments").width(), 10), '', JSON.stringify({ "rrid": me.options.parameter.rid  }), 1);
            }

        } catch (e) {
            me.writeError('_showSubLists', e);
            return false;
        }
        return true;
    },



    _save: function () {
        /// <summary>
        /// This function saves the settings
        /// </summary>
        var me = this;
        try {
            me.fnd(" #div-period").removeClass("formItemValid, formItemInvalid");

            var param = {};
            param.type = 1;
            param.ReportTypeId = parseInt(me.fnd("#ddl-report-type").val());
            param.DataTypeId = parseInt(me.fnd("#ddl-data-type").val());
            param.Period = parseInt(me.fnd(" #txt-period").val());

            var valid = validateInteger(param.Period);
            if (valid && param.Period < 1) { valid = false }

            if (!valid) {
                me.fnd("#div-period").addClass("formItemInvalid");
                me.openInfoDialog(me.specific.resources.ERR_inputInvalid, { at: 'center center-20%', of: window }); return false;
            } else {
                me.fnd("#div-period").addClass("formItemValid");
            }
            
            
            if (me.useSignalAssignment) {
                param.Specific = {};
                param.Specific.MergeProjects = me.fnd("#chb-merge-projects").prop("checked");
                param.Specific.SingleExport = me.fnd("#chb-single-export").prop("checked");
                param.Specific.PriceType = parseInt(me.fnd("#ddl-price-type").val());
            } else {
                param.Specific = { MergeProjects: false, SingleExport:false,PriceType:0};
            }


            me.updateData(param, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                if (result == false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                me.fnd("#div-btn-save").button("disable");
                return true;
            });

        } catch (e) { me.writeError('save', e); return false; }
        return true;
    },


    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

